import React from 'react';

// User identity context (Phase B4 stub).
//
// Currently `user` flows through the App tree as a prop. Future Phase B
// extractions migrate consumers to `useContext(UserContext)` one
// component at a time. Today, the App root sets the value here but every
// existing consumer continues reading from props — no behavior change.
//
// Shape: the same user row getActingUser() returns on the server,
//   { id, name, role, location_id, location_ids, primary_location_id,
//     email, ... } or null when not signed in.

const UserContext = React.createContext(null);

export { UserContext };
export default UserContext;
